import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import PieChartIcon from "@mui/icons-material/PieChart";
import EventNoteIcon from "@mui/icons-material/EventNote";
import BugReportIcon from "@mui/icons-material/BugReport";
import GroupIcon from "@mui/icons-material/Group";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import StairsIcon from "@mui/icons-material/Stairs";
import { withRouter } from "react-router";
import { useHistory, Link } from "react-router-dom";
import { useAuthUser } from "../../store/AuthUserContextProvider";

const DrawerMenuItems = () => {
  const history = useHistory();
  const { authUser } = useAuthUser();

  const DEFAULT_MENU_TABS = [
    // {
    //   label: "Scheduler",
    //   icon: <EventNoteIcon />,
    //   route: "/scheduler",
    // },
    {
      label: "Global Worklist",
      icon: <AssessmentIcon />,
      route: "/worklist",
    },
    {
      label: "My Worklist",
      icon: <AssessmentIcon />,
      route: "/my-worklist",
    },
    {
      label: "Reporting",
      icon: <PieChartIcon />,
      route: "/reporting",
    },
    {
      label: "Pacs",
      icon: <BugReportIcon />,
      route: "/pacs",
    },
  ];

  const ADMIN_TABS = [
    {
      label: "Users",
      icon: <GroupIcon />,
      route: "/users",
    },
    {
      label: "Branches",
      icon: <AccountTreeIcon />,
      route: "/branches",
    },
    {
      label: "Procedures",
      icon: <StairsIcon />,
      route: "/procedures",
    },
  ];

  return (
    <List
      sx={{
        height: "100%",
        overflow: "auto",
        background: "rgb(0,0,0)",
      }}
    >
      {authUser.Role === "ref-doctor" ? (
        <>
          <Link to={"/ref-doctor-worklist"} key={"Ref-doctor Worklist"}>
            <ListItem
              button
              sx={{
                background:
                  history.location.pathname === "/ref-doctor-worklist"
                    ? "#f44336"
                    : "",
                border:
                  history.location.pathname === "/ref-doctor-worklist"
                    ? "1px #f44336 solid"
                    : "1px transparent solid",
              }}
            >
              <ListItemIcon>
                <AssessmentIcon />
              </ListItemIcon>
              <ListItemText primary={"Ref-doctor Worklist"} />
              <Divider />
            </ListItem>
          </Link>
        </>
      ) : (
        <>
          {authUser.Role !== "ref-doctor" && ADMIN_TABS.map((item) => (
            <Link to={item.route} key={item.label}>
              <ListItem
                button
                sx={{
                  background:
                    history.location.pathname === item.route ? "#f44336" : "",
                  border:
                    history.location.pathname === item.route
                      ? "1px #f44336 solid"
                      : "1px transparent solid",
                }}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.label} />
                <Divider />
              </ListItem>
            </Link>
          ))}

          <Divider />

          {authUser.Role !== "ref-doctor" && DEFAULT_MENU_TABS.map((item) => (
            <Link to={item.route} key={item.label}>
              <ListItem
                button
                sx={{
                  background:
                    history.location.pathname === item.route ? "#f44336" : "",
                  border:
                    history.location.pathname === item.route
                      ? "1px #f44336 solid"
                      : "1px transparent solid",
                }}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.label} />
                <Divider />
              </ListItem>
            </Link>
          ))}
        </>
      )}

      <Divider />
      {authUser.Role !== "ref-doctor" &&(
      <ListItem
      onClick={()=>{window.open(`http://169.1.16.176:3001`, '_blank');}}
      >
         <ListItemIcon>
         <EventNoteIcon />
        </ListItemIcon>
        <ListItemText primary={"open Scheduler"} />
      </ListItem>
)}
      <ListItem
        button
        onClick={() => {
          localStorage.clear();
          history.push("/login");
        }}
      >
        <ListItemIcon>
          <ExitToAppIcon />
        </ListItemIcon>
        <ListItemText primary={"Logout"} />
        <Divider />
      </ListItem>
    </List>
  );
};

export default withRouter(DrawerMenuItems);
